/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Err_Tournament_Vekn_Frozen_FieldInputs */



/**
* | output |
* | --- |
* | "Cannot change {field} after the event is published to VEKN" |
*
* @param {Err_Tournament_Vekn_Frozen_FieldInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_vekn_frozen_field = /** @type {((inputs: Err_Tournament_Vekn_Frozen_FieldInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Vekn_Frozen_FieldInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de modifier ${i?.field} après la publication de l'événement sur VEKN`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede cambiar ${i?.field} después de que el evento se haya publicado en la VEKN`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Não é possível alterar ${i?.field} após a publicação do evento na VEKN`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile modificare ${i?.field} dopo la pubblicazione dell'evento sulla VEKN`)
	return /** @type {LocalizedString} */ (`Cannot change ${i?.field} after the event is published to VEKN`)
});